export default {
  brandDesc:
    "La agencia de consultoría de food trucks líder del Condado de Orange. Ayudamos a los operadores a navegar permisos, regulaciones y estrategias de crecimiento.",
  address: "Santa Ana, Condado de Orange, CA",
  officeHours: "Horario de Oficina",
  hours: [
    { day: "Lunes – Viernes", hours: "7:00 AM – 7:00 PM" },
    { day: "Sábado", hours: "Solo con Cita" },
    { day: "Domingo", hours: "Cerrado" },
  ],
  quickLinks: "Enlaces Rápidos",
  quickServices: "Servicios",
  quickHowToOperate: "Cómo Operar",
  quickRegulations: "Regulaciones y Permisos",
  quickBookSession: "Reservar una Sesión",
  bookSession: "Reservar una Sesión",
  copyright: "My Food Truck Agency. Todos los derechos reservados.",
  serving: "Sirviendo al Condado de Orange, CA desde 2025",
};